import { render } from "./UsuarioCadastro.vue?vue&type=template&id=1455c673&ts=true"
import script from "./UsuarioCadastro.vue?vue&type=script&lang=ts"
export * from "./UsuarioCadastro.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\UniRH\\FrontEnd\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__